import { useCallback, useEffect, useMemo, useRef, useState } from "react";
export const useConfirmTouch = (duration: number = 2000) => {
  const stiRef = useRef<number | null>(null);
  const [idle, setIdle] = useState<boolean | undefined>();
  const confirm = useMemo(() => idle === false, [idle]);

  const onClick = useCallback(() => {
    if (!idle) {
      stiRef.current = window.setTimeout(() => setIdle(undefined), duration);
      setIdle(true);
      return false;
    }

    if (stiRef.current) clearTimeout(stiRef.current);
    setIdle(false);
    return true;
  }, [idle, duration]);
  const bindClick = useCallback(
    (callback: () => unknown) => () => {
      if (onClick()) callback();
    },
    [onClick]
  );

  useEffect(() => {
    return () => {
      if (stiRef.current) {
        clearTimeout(stiRef.current);
      }
    };
  }, []);

  return {
    confirm,
    onClick,
    idle,
    bindClick,
  };
};
